import React, { useMemo } from "react";
import Button from "../../../Button/Button";
import Tooltip from "../../../Tooltip/Tooltip";
import PublishDetails from "../../../PublishDetails/PublishDetails";
import Icon from "../../../Icon2/Icon";
import cbModal from "../../../Modal/Modal";
import { PublishDetailsModal } from "../PublishDetailsModal/PublishDetailsModal";
import { PublishStatus as IPublishStatus } from "../../types";
import "./PublishStatus.css";

const VISIBLE_ITEM_COUNT = 2;

export interface PublishStatusProps {
  publishStatuses: IPublishStatus[];
  currentVersion?: string;
  currentLocale: string;
}

export const PublishStatus = (props: PublishStatusProps) => {
  const { publishStatuses = [], currentLocale, currentVersion } = props;
  const publishStatusItems = useMemo(() => {
    if (!currentLocale) {
      return publishStatuses;
    }
    return publishStatuses.filter((status) => status.locale === currentLocale);
  }, [publishStatuses, currentLocale])

  // only show the first two status and show all in a modal
  const publishStatusList = [...publishStatusItems].splice(0, VISIBLE_ITEM_COUNT);
  const moreStatusCount = publishStatusItems.length - VISIBLE_ITEM_COUNT;

  const openPublishDetailsModal = (event: React.MouseEvent<HTMLSpanElement>) => {
    // stop propagation to avoid row selection in entry table
    event.stopPropagation();
    cbModal({
      component: (modalProps: any) =>
        <PublishDetailsModal
          publishStatuses={publishStatusItems}
          closeModal={modalProps?.closeModal}
        />,
      modalProps: {
        size: "small"
      }
    })
  }

  return (
    <>
      {publishStatusList.map((status, index) => {
        return (
          <Tooltip
            key={status.time}
            position="left"
            variantType="light"
            content={
              <PublishDetails
                color={status.environment.color}
                environment={status.environment.name}
                version={`Version ${status.version}`}
                locale={status.locale}
                userName={status.userName}
                scheduledAt={status.time}
              />
            }
          >
            <>
              <Icon
                className="publish-status__env-icon"
                icon="EnvironmentColor"
                fill={status.environment.color}
                testId="cs-publish-status__env-icon"
              />
              <span
                className="publish-status__env-name"
                data-test-id="cs-publish-status__env-name">
                {status.environment.name}
              </span>
              {status.scheduledAt ?
                <Icon icon="ClockDark" className="mr-5 ml-5" testId="publish-status__scheduled-icon" /> :
                currentVersion === status.version ?
                  <Icon icon="InfoGreen" className="ml-5" /> :
                  <Icon icon="InfoYellow" className="ml-5" />
              }
            </>
          </Tooltip>
        )
      })}
      {moreStatusCount > 0 ? (
        <Button
          className="publish-status__more-button"
          onClick={openPublishDetailsModal}
          buttonType="tertiary"
          size="small"
          version="v2"
          testId="publish-status__more-button"
        >
          {`+ ${moreStatusCount} more`}
        </Button>
      ) : null}
      {publishStatusList.length === 0 ? (
        <div>Not Published</div>
      ) : null}
    </>
  )
}